export default {
  common: { black: '#000', white: '#fff' },
  background: {
    light: '#F4F6F8',
    lightBlue: '#DDE7F0',
    dark: '#323D59',
    darker: '#061227',
    default: '#fff',
    paper: '#fff',
    error: '#fcf5f5',
  },
  primary: {
    main: '#38C2D6',
    light: '#1fbfd6',
    lighter: '#e0fbff',
    lightest: '#f3fafb',
    dark: '#008ea5',
    darker: '#148A93',
    contrastText: '#fff',
  },
  secondary: {
    main: '#EF4766',
    light: '#ff718b',
    lighter: '#ffd7de',
    lightest: '#ffe9ed',
    dark: '#b70035',
    darker: '#BA3152',
  },
  error: {
    light: '#e5a0a0',
    main: '#de4c4c',
    dark: '#992c2c',
  },
  warning: {
    light: '#f6d287',
    main: '#ffb00c',
    dark: '#b77c01',
  },
  success: {
    light: '#81c784',
    main: '#4caf50',
    dark: '#388e3c',
  },
  divider: '#e4e4e4',
  darkDivider: '#c7c7c7',
  text: {
    primary: '#242f4a',
    secondary: 'rgba(36, 45, 62, 0.7)',
    secondaryLight: '#9ca8b3',
    disabled: '#a0a3a8',
    hint: '#9ca8b3',
    // hint: '#DDE7F0',
    icon: 'rgba(255, 255, 255, 0.5)',
    gray: 'rgba(0, 0, 0, 0.6)',
    disabledLabel: '#b2b2b2',
  },
  ndis: {
    primary: '#6a2376',
    secondary: '#82c53e',
  },
};
